module.exports = __webpack_public_path__ + "static/media/rectangle-landscape.0cf44514.svg";